import * as React from "react";
import { forwardRef } from "react";
const SvgIcClose24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-close-24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M13.4295 11.7851L19.5814 5.46796L18.1518 4L12 10.3171L5.84819 4.00001L4.41865 5.46796L10.5704 11.7851L4 18.532L5.42955 20L12 13.253L18.5705 20L20 18.532L13.4295 11.7851Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcClose24);
export { ForwardRef as ReactComponent };
